export default {

  setUsers(state, data) {
    state.users = data;
  },
  setUser(state, data) {
    state.user = data;
  },
  setBannedUser(state, data){
    state.bannedUser = data;
  },
  setRoles(state, data) {
    state.roles = data;
  },
  setCustomers(state, data) {
    state.customers = data;
  },
  setBlockCustomers(state, data) {
    state.blockCustomers = data;
  },
  setPermissions(state, data) {
    state.permissions = data;
  },

  setEmployees(state, data) {
    state.employees = data;
  },
  setDeletedEmployees(state, data) {
    state.deletedEmployees = data;
  },
  setEmployee(state, data) {
    state.employee = data;
  },

  setPersons(state, data) {
    state.persons = data;
  },
  setPerson(state, data) {
    state.person = data;
  },
  setOrdersUser(state, data) {
    state.OrdersUser = data;
  }

};
